import React from "react";
import {
  MissionListActionsContainer,
  MissionListActionsInputMaster,
  MissionListActionsNavigation,
  MissionListActionsRoot,
} from "./MissionListActions.styles";
import { MissionListSortByDropdown } from "./MissionListSortByDropdown";
import { MissionListSearchInput } from "./MissionListSearchInput";

export const MissionListActions = ({
  search,
  setSearch,
  sortValue,
  setSortValue,
}: {
  search: string;
  setSearch: (v: string) => void;
  sortValue: string;
  setSortValue: (v: string) => void;
}) => {
  const sortOptions = [
    { label: "Last Updated", value: "updatedAt" },
    { label: "Last Deployed", value: "lastDeployed" },
  ];
  return (
    <MissionListActionsRoot>
      <MissionListActionsInputMaster>
        <MissionListActionsContainer>
          <MissionListSearchInput
            value={search}
            onChange={setSearch}
            placeholder="Search mission"
          />
        </MissionListActionsContainer>
      </MissionListActionsInputMaster>
      <MissionListActionsNavigation>
        <MissionListSortByDropdown
          label="Sort by"
          options={sortOptions}
          value={sortValue}
          onChange={(opt) => setSortValue(opt.value)}
          width={169}
        />
      </MissionListActionsNavigation>
    </MissionListActionsRoot>
  );
};
